import { useSearchParams } from 'react-router-dom';

import { useTableContext } from 'lib/context/TableContext/TableContext';
import { ia } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import { getActiveFilters } from 'components/shared/Filters/lib/helpers';
import Icon from 'components/shared/Icon/Icon';

const EmptyData = () => {
  const { filters, updateFilters } = useTableContext();
  const [_, setSearchParams] = useSearchParams();

  const isFilterApplied = ia(getActiveFilters(filters));

  if (isFilterApplied) {
    return (
      <div className="flex flex-col items-center gap-1">
        <Icon icon="illustration-empty-table" />
        <h1 className="text-base font-500 text-primary-900">No results match your filters</h1>
        <h4 className="text-sm text-neutral-600">Adjust the filters to see more results.</h4>
        <Button
          text="Clear Filters"
          icon="close-square-mono"
          variant="link"
          size="xs"
          onClick={() => {
            setSearchParams({});
            updateFilters(null);
          }}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center">
      <Icon icon="illustration-empty-table" />
      <h1 className="text-base font-500 text-primary-900">No Data Available</h1>
    </div>
  );
};

export default EmptyData;
